import { compose, renameProp, withHandlers, defaultProps } from 'recompose'
import * as R from 'ramda'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

const enhance = compose(
  defaultProps({
    onChange: R.identity,
  }),
  renameProp('onChange', 'onChangeCallback'),
  toReduxFormField('InputSelect'),
  withHandlers({
    handleChange:
      ({ input: { onChange }, onChangeCallback }) =>
      value => {
        onChange(value)
        onChangeCallback(value)
      },
  }),
)

export default enhance
